"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h4", {
  className: "text-primary"
}, "Payments"), /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "This tab lists all online payments and refunds."), /*#__PURE__*/_react.default.createElement("p", null, "All amounts refer to the actual fees for the club. Online booking fees are not shown."), /*#__PURE__*/_react.default.createElement("h5", null, "Payment Status"), /*#__PURE__*/_react.default.createElement("dl", {
  className: "clearfix"
}, /*#__PURE__*/_react.default.createElement("dt", {
  className: "col-sm-3"
}, "Payment Pending"), /*#__PURE__*/_react.default.createElement("dd", {
  className: "col-sm-9"
}, "The paddler has provided their card details but the card has not yet been charged."), /*#__PURE__*/_react.default.createElement("dt", {
  className: "col-sm-3"
}, "Payments Received"), /*#__PURE__*/_react.default.createElement("dd", {
  className: "col-sm-9"
}, "The paddlers card account has been charged."), /*#__PURE__*/_react.default.createElement("dt", {
  className: "col-sm-3"
}, "Cancelled before charged"), /*#__PURE__*/_react.default.createElement("dd", {
  className: "col-sm-9"
}, "The payment has been refunded in full before any charge has been taken from the paddler's account."), /*#__PURE__*/_react.default.createElement("dt", {
  className: "col-sm-3"
}, "Pending Retry"), /*#__PURE__*/_react.default.createElement("dd", {
  className: "col-sm-9"
}, "The first attempt to charge the paddler's account has failed. A second attempt will be made automatically within 24hrs. If this fails then the paddler will be sent a request for new details and the status updated."), /*#__PURE__*/_react.default.createElement("dt", {
  className: "col-sm-3"
}, "Charge Failed"), /*#__PURE__*/_react.default.createElement("dd", {
  className: "col-sm-9"
}, "The paddler's bank has rejected the charge. The paddler has been sent an email requesting them to re-enter payment details; it is recommended that the organiser chases paddlers where this is not resolved within 2-3 days.")), /*#__PURE__*/_react.default.createElement("h5", null, "Entries"), /*#__PURE__*/_react.default.createElement("p", null, "These are the original entries for which payment was made (including any cancelled entries)."), /*#__PURE__*/_react.default.createElement("h5", null, "Refunds"), /*#__PURE__*/_react.default.createElement("p", null, "This is a list of refunds made against the payment. Normally refunds will show a status of Refunded, however, where there are insufficient funds in the club stripe account to make an immediate refund, the refund may show as pending."));
const PaymentsHelp = () => {
  return _ref;
};
var _default = exports.default = PaymentsHelp;